export enum RideTypeCategoryEnum {
  Normal = "Normal",
  LockedEndDate = "LockedEndDate",
  IndependentDayAdjustment = "IndependentDayAdjustment",
}
